// extracted by mini-css-extract-plugin
export default {"container":"Grx1wUzMJlOGKhr","own-farming-logo":"Kyi5Inq_1BKUjq2","header":"dby5W2aQwLd8tnS","content":"ZppmvrQ7WJH4s_M","footer":"truQgdgh1emjuDU"};